<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.DECLINE_SALES_ORDER.DESCRIPTION' | translate }}
  </div>
  <div class="alert-wrapper">
    <glxy-alert type="tip">
      <div
        [innerHtml]="'AUTOMATIONS.EDITOR.TASKS.DECLINE_SALES_ORDER.ACTION.DISCLAIMER_V2' | translate | iTrustThisHtml"
      ></div>
    </glxy-alert>
  </div>
  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.TASKS.DECLINE_SALES_ORDER.DECLINED_REASON' | translate }}
    </glxy-label>
    <mat-select required [formControl]="usePreviousStepControl">
      <mat-option [value]="false">
        {{ 'AUTOMATIONS.EDITOR.TASKS.DECLINE_SALES_ORDER.SPECIFY_NEW' | translate }}
      </mat-option>
      <mat-option [value]="true">
        {{ 'AUTOMATIONS.EDITOR.TASKS.DECLINE_SALES_ORDER.USE_FROM_PREVIOUS_STEP' | translate }}
      </mat-option>
    </mat-select>
    <glxy-error *ngIf="usePreviousStepControl.hasError('required')">
      {{ 'AUTOMATIONS.EDITOR.ERRORS.REQUIRED' | translate }}
    </glxy-error>
  </glxy-form-field>
  <ng-container *ngIf="!usePreviousStepControl.value; else displayPreviousStepOptions">
    <ng-container *ngIf="declinedReasonOptions$ | async as declinedReasonOptions; else loading">
      <form [formGroup]="form">
        <glxy-form-field *ngIf="declinedReasonOptions.length > 0" [required]="true">
          <glxy-label>
            {{ 'AUTOMATIONS.EDITOR.TASKS.DECLINE_SALES_ORDER.DECLINED_REASON' | translate }}
          </glxy-label>
          <mat-select [formControl]="declinedReasonIdControl">
            <mat-option *ngFor="let declinedReasonOption of declinedReasonOptions" [value]="declinedReasonOption.id">
              {{ declinedReasonOption.reason }}
            </mat-option>
          </mat-select>
          <glxy-error *ngIf="declinedReasonIdControl.hasError('required')">
            {{ 'AUTOMATIONS.EDITOR.ERRORS.REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
        <glxy-form-field [required]="true">
          <glxy-label>
            <ng-container *ngIf="declinedReasonOptions.length === 0">
              {{ 'AUTOMATIONS.EDITOR.TASKS.DECLINE_SALES_ORDER.DECLINED_REASON' | translate }}
            </ng-container>
            <ng-container *ngIf="declinedReasonOptions.length > 0">
              {{ 'AUTOMATIONS.EDITOR.TASKS.DECLINE_SALES_ORDER.ADD_MORE_DETAIL' | translate }}
            </ng-container>
          </glxy-label>
          <textarea
            id="decline-reason"
            matInput
            [formControl]="declinedReasonFreeTextControl"
            cdkTextareaAutosize
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="8"
            [required]="true"
          ></textarea>
          <automata-automation-variable-menu
            matSuffix
            useGalaxyCompat="true"
            (variableSelected)="insertVariable('decline-reason', declinedReasonFreeTextControl, $event)"
          ></automata-automation-variable-menu>
          <glxy-error *ngIf="declinedReasonFreeTextControl.hasError('required')">
            {{ 'AUTOMATIONS.EDITOR.TASKS.DECLINE_SALES_ORDER.REQUIRED_FIELD' | translate }}
          </glxy-error>
        </glxy-form-field>
      </form>
    </ng-container>
  </ng-container>
  <ng-template #displayPreviousStepOptions>
    <ng-container *ngIf="previousStepOptions$ | async as previousStepsWithApplicableOutputs">
      <glxy-form-field [required]="true">
        <glxy-label>
          {{ 'AUTOMATIONS.COMMON.STEP' | translate }}
        </glxy-label>
        <mat-select required [formControl]="previousStepOptionsControl">
          <mat-option *ngFor="let previousStep of previousStepsWithApplicableOutputs" [value]="previousStep.value">
            {{ previousStep.title }}
          </mat-option>
        </mat-select>
        <glxy-error *ngIf="previousStepOptionsControl.hasError('required')">
          {{ 'AUTOMATIONS.EDITOR.ERRORS.REQUIRED' | translate }}
        </glxy-error>
      </glxy-form-field>
    </ng-container>
  </ng-template>

  <ng-template #loading>
    <div class="content side-drawer-shimmer-container">
      <span class="control-container selector stencil-shimmer"></span>
      <span class="control-container selector stencil-shimmer"></span>
      <span class="control-container selector stencil-shimmer"></span>
    </div>
  </ng-template>
</div>
